'use client';

import { useState, useEffect } from 'react';
import { MdOutlineKeyboardArrowUp } from "react-icons/md";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="p-1 bg-secondary text-yel rounded-full shadow-lg hover:bg-bl-dark transition-all bg-opacity-40"
        >
          <MdOutlineKeyboardArrowUp size={40} className='hover:text-bl font-bold'/>
        </button>
      )}
    </div>
  );
}